<div>
    This option allows you to initialize an order form from a local text file.<br/><br/>
    The format of this file will be<br/> "MCLANE ITEM NUMBER,QUANTITY"<br/><br/>
    Sample lines in order file:<br/><br/>
    101505,5<br>
    101754,2<br/><br/>
    If you are unsure of how to use this option, please contact the SourceLink&reg; Support
    Center toll-free at <br/> 1-800-543-3333.<br/>
</div>
